import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import { cn } from "@/lib/utils";

const Tabs = TabsPrimitive.Root;

// Alternador-pill PADRÃO do app: track arredondado + pill sólida no ativo. A cor é
// AZUL (`#2f6fae`), DE PROPÓSITO diferente do verde dos botões de ação — assim um
// alternador de aba nunca se confunde com um CTA (ver CLAUDE.md #20). O ativo usa a
// mesma receita 3D do Button3D: base escura de 4px (inset) + o shift de pb pra
// centralizar o texto na face clara (`pb = py + 4px`).
const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      // Track SÓLIDO, com a mesma superfície dos cartões do desenho oficial
      // (`CONTENT_CARD`: `bg-card` + `border-border/60` + `shadow-sm`).
      //
      // Antes era um tint translúcido da cor ativa (`bg-[#2f6fae]/10`), e a
      // translucidez é o defeito: o track deixava passar o que estivesse atrás.
      // Sobre o hero verde de `/quotes` (onde o conteúdo sobe e encosta na
      // curva, #188) o "azul-claro" virava verde, e a barra deixava de ser um
      // objeto para virar um borrão — a mesma barra com duas caras conforme a
      // página. Sólido, ela é sempre a mesma coisa.
      //
      // `bg-card` e não `bg-white`: é o token que os cartões usam, então o
      // dark mode acompanha sozinho — um branco literal ficaria berrante lá.
      // E a sombra é a MESMA dos cartões (`shadow-sm` + borda), que é o que
      // separa a barra do branco da página sem inventar um segundo relevo.
      "inline-flex h-12 items-center justify-center rounded-full border border-border/60 bg-card p-1 text-muted-foreground shadow-sm",
      className,
    )}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex h-full items-center justify-center whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-[#2f6fae] data-[state=active]:text-white data-[state=active]:shadow-[inset_0_-4px_0_rgba(23,52,90,0.32),0_6px_12px_rgba(37,90,150,0.28)] data-[state=active]:pb-[calc(0.375rem_+_4px)]",
      className,
    )}
    {...props}
  />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      className,
    )}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
